import React, { useState } from 'react';
import styled from 'styled-components';
import { Grid, Button, ISelectOption } from 'ui-toolkit';
import { AdvancedOrdersSearchForm } from './AdvancedOrdersSearchForm';
import { Form, Formik } from 'formik';
import { ICountiesData } from '../../store/counties';
import { eUSAState } from '../../ui-toolkit/enums/states';
import { DefaultOrdersSearchForm } from '../../ui-toolkit/orders/searchOrder/components/DefaultOrdersSearchForm';
import { searchOrdersSpecification } from '../../ui-toolkit/orders/searchOrder/validation/searchOrdersSpecification';
import {
  createDefaultSearchOrderSpecification,
  ISearchOrdersSpecificationData,
} from '../../ui-toolkit/orders/searchOrder/types/ISearchOrdersSpecification';

const SearchButtonsDiv = styled.div`
  display: grid;
  gap: ${(props) => props.theme.spacing.spacing5};
`;

interface IOrdersSearchFormProps {
  lenders: Array<ISelectOption<string>>;
  onSearchOrder: (value: ISearchOrdersSpecificationData) => void;
  counties: ICountiesData;
  onStateSelect: (statee: eUSAState | null) => void;
}

export const OrdersSearchForm: React.FC<IOrdersSearchFormProps> = ({
  lenders,
  onSearchOrder,
  counties,
  onStateSelect,
}) => {
  const [advancedSearch, setAdvancedSearch] = useState(false);
  return (
    <Formik
      initialValues={createDefaultSearchOrderSpecification()}
      validationSchema={searchOrdersSpecification(lenders, [])}
      onSubmit={(values, formikHelpers) => {
        onSearchOrder(values);
      }}
      onReset={(values, formikHelpers) => {
        setAdvancedSearch(false);
        formikHelpers.setValues(createDefaultSearchOrderSpecification());
        onSearchOrder(createDefaultSearchOrderSpecification());
      }}
    >
      {({ values, handleSubmit, isValid }) => (
        <Form onSubmit={handleSubmit}>
          <Grid templateColumns={'1fr max-content'} alignItems={'start'}>
            <div>
              {advancedSearch ? (
                <AdvancedOrdersSearchForm
                  lenders={lenders}
                  onStateSelect={onStateSelect}
                  counties={values.state ? counties[values.state] : []}
                />
              ) : (
                <DefaultOrdersSearchForm />
              )}
              <Button intent="ghost" isInline type={'button'} onClick={() => setAdvancedSearch(!advancedSearch)}>
                {advancedSearch ? 'Basic Search' : 'Advanced Search'}
              </Button>
            </div>
            <SearchButtonsDiv>
              <Button intent="primary" type={'submit'} disabled={!isValid}>
                Search
              </Button>
              <Button intent="ghost" isInline type={'reset'}>
                Clear Search
              </Button>
            </SearchButtonsDiv>
          </Grid>
        </Form>
      )}
    </Formik>
  );
};
